import { useEffect, useRef } from 'react'

interface StepEnterScrollTopProps {
  scrollContainerAttr: string
}

const StepEnterScrollTop = ({ scrollContainerAttr }: StepEnterScrollTopProps) => {
  const anchorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const stepWrapper = anchorRef.current?.closest<HTMLElement>(
      `[${scrollContainerAttr}]`
    )
    if (!stepWrapper) return

    stepWrapper.scrollTop = 0
    stepWrapper.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [scrollContainerAttr])

  return <div ref={anchorRef} />
}

export default StepEnterScrollTop
